import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Manager } from "@lib/types/Manager";

export const apiGetManager = async <T extends ApiParams>(
  managerId: string,
  params?: T,
) => {
  const url = ApiUrlPrepare({
    params,
    url: `/payment-hub-manager/${managerId}`,
  });
  return API.get<Manager>(url);
};

export const apiAddManager = async (data: Manager) => {
  return API.post<Manager>(`/payment-hub-manager`, data);
};

export const apiDeleteManager = async (data: Manager) => {
  return API.delete<null>(`/payment-hub-manager/${data.id}`);
};

export const apiUpdateManager = async (data: Partial<Manager>) => {
  const { id, ...rest } = data as Manager;
  if (!rest?.password) {
    delete rest.password;
  }
  return API.patch<Manager>(`/payment-hub-manager/${id}`, rest);
};

export const apiGetManagers = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/payment-hub-manager` });
  return API.get<PaginationType<Manager>>(url);
};
